/**
 * Shared constants and small UI helpers used across the WebsiteOrders
 * sub-components (list, place-order form, cancel-item modal).
 *
 * Extracted from `WebsiteOrdersPanel.jsx` (Feb 2026, code-quality refactor).
 * Pure presentation only — no API calls, no business rules.
 */

export const PAYMENT_TYPES = ["CRM", "razorpay", "stripe", "paypal", "cod", "bank-transfer", "upi", "other"];
export const CURRENCIES = ["INR", "USD", "EUR", "GBP", "CAD", "AUD", "SGD", "AED"];

export const INPUT_CLASS = "w-full bg-white border border-slate-200 rounded-lg px-2 py-1.5 text-[11px] outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-100 transition-all";

export const StatusBadge = ({ status }) => {
  const norm = String(status || "").toLowerCase();
  let cls = "bg-slate-100 text-slate-700 border-slate-200";
  if (norm.includes("deliver")) cls = "bg-emerald-50 text-emerald-700 border-emerald-200";
  else if (norm.includes("ship")) cls = "bg-blue-50 text-blue-700 border-blue-200";
  else if (norm.includes("cancel")) cls = "bg-rose-50 text-rose-700 border-rose-200";
  else if (norm.includes("pending") || norm.includes("process")) cls = "bg-amber-50 text-amber-700 border-amber-200";
  return (
    <span className={`text-[9px] font-extrabold uppercase tracking-wider px-1.5 py-0.5 rounded-full border ${cls}`}>
      {status || "—"}
    </span>
  );
};

export const formatMoney = (amount, currency, notation) => {
  if (!amount && amount !== 0) return "—";
  const sym = notation || (currency === "USD" ? "$" : currency === "EUR" ? "€" : currency === "GBP" ? "£" : currency === "INR" ? "₹" : (currency || ""));
  const n = Number(amount);
  return `${sym}${isNaN(n) ? amount : n.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
};

export const Field = ({ label, children, testid }) => (
  <label className="block" data-testid={testid}>
    {label && <span className="text-[9px] font-bold uppercase tracking-wider text-slate-500 block mb-0.5">{label}</span>}
    {children}
  </label>
);
